import React from "react";
import { Theme, StandardProps, Typography } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/styles";
import { StyleClassKey } from "js/react/typescript";
import { UploadProgress } from "js/react/scenes/components/MediaManagement";
import PendingUploadRow from "js/react/scenes/components/MediaManagement/PendingUploadRow";
import { UploadStatus } from "js/react/scenes/components";

const styles = (theme: Theme) =>
    createStyles({
        root: {
            padding: theme.spacing(1),
            display: "flex",
            position: "fixed",
            bottom: "0px",
            flexDirection: "column",
            maxHeight: "150px",
            backgroundColor: theme.palette.primary.main
        },
        title: {
            color: theme.palette.common.white,
            fontWeight: 600,
            fontSize: "1.1em"
        },
        contentRoot: {
            overflowY: "auto"
        }
    });

type PendingUploadsClassKey = StyleClassKey<typeof styles>;

const useStyles = makeStyles(styles);

export interface PendingUploadsProps
    extends StandardProps<{}, PendingUploadsClassKey> {
    uploadsList: UploadProgress[];
    onUpdate: (uploadsList: UploadProgress[]) => void;
    width?: number;
}

function Component(props: PendingUploadsProps) {
    const classes = useStyles(props);
    const { uploadsList, onUpdate, width } = props;

    return (
        <div
            className={classes.root}
            style={{ width: width ? width + 1 + "px" : "100%" }}
        >
            <Typography variant="body1" className={classes.title}>
                {uploadsList.filter(x => x.status === UploadStatus.IN_PROGRESS)
                    .length + " uploads pending"}
            </Typography>
            <div className={classes.contentRoot}>
                {uploadsList.map((u, idx) => (
                    <PendingUploadRow
                        upload={u}
                        key={idx}
                        onDelete={() =>
                            onUpdate(
                                uploadsList.filter(
                                    u2 => u.fileName !== u2.fileName
                                )
                            )
                        }
                    />
                ))}
            </div>
        </div>
    );
}

Component.defaultProps = {} as PendingUploadsProps;
Component.displayName = "PendingUploads";
export const PendingUploads = Component;
export default PendingUploads;
